
import Vue from "vue";
import AppColumnSelect from "@/components/models/ColumnSelect.vue";
import { TextLine } from "@/utils/label-layout/text-line";
import { Model } from "@/utils/models/model";
import { LabelLayout } from "@/utils/label-layout/label-layout";
import { BrowseService } from "@/services";
import { Browse } from "@/models/browse";
import AppStyleEditor from "../layout-editor/StyleEditor.vue";
import AppBasicTextStyleEditor from "../layout-editor/BasicTextStyleEditor.vue";
import { TextStyledProperty } from "@/utils/documents/text-styled-property";
import { ISelectItem } from "winfakt-vue-components";
import { BasicTextStyledProperty } from "@/utils/documents/basic-text-styled-property";
import { ModelNamedProperty } from "@/utils/models/named-property";

export default Vue.extend({
	data(){
		return {
			line: new TextLine(),
			toEditStyleProp: null as null | "pre" | "prop" | "post",
			editContainerStyle: false
		};
	},
	props: {
		value: {
			type: Object as ()=>TextLine,
			required: true
		},
		model: {
			type: Object as ()=>Model,
			required: true
		},
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	computed: {
		browse():Browse | null{
			return BrowseService.getBrowseWithoutViewSettings(this.layout.BrowseID);
		},
		toEditStyle():null | BasicTextStyledProperty {
			if (this.toEditStyleProp == "pre") {
				return this.line.PreTextStyle;
			}
			if (this.toEditStyleProp == "prop") {
				return this.line.PropStyle;
			}
			if (this.toEditStyleProp == "post") {
				return this.line.PostTextStyle;
			}
			return null;
		},
		styleExtraActions():ISelectItem<Function>[]{
			let ref = this;
			return [
				{
					text: this.$ct("apply-style-to-all-fields"),
					value(style:TextStyledProperty){
						ref.line.PreTextStyle = new TextStyledProperty(style.getJSON());
						ref.line.PostTextStyle = new TextStyledProperty(style.getJSON());
						ref.line.PropStyle = new TextStyledProperty(style.getJSON());
						ref.$wf.notify(ref.$ct("styles-applied"), "success", 3000, "check");
					}
				}
			];
		},
		selectedProp():ModelNamedProperty | undefined{
			return this.model.getField(this.line.Prop);
		},
		isNumber():boolean {
			if (!this.selectedProp) return false;
			return this.selectedProp.field.type == "number";
		}
	},
	watch: {
		input: {
			immediate: true,
			handler(){
				this.line = new TextLine(this.value.getJSON());
			}
		},
		isNumber(){
			if (!this.isNumber) {
				this.toggleRounding(false);
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", new TextLine(this.line.getJSON()));
			this.close();
		},
		editPreTextStyle(){
			this.toEditStyleProp = "pre";
		},
		editPostTextStyle(){
			this.toEditStyleProp = "post";
		},
		editPropStyle(){
			this.toEditStyleProp = "prop";
		},
		setStyle(style:TextStyledProperty){
			if (this.toEditStyleProp == "pre") {
				this.line.PreTextStyle = style;
			}else if (this.toEditStyleProp == "prop") {
				this.line.PropStyle = style;
			}else if (this.toEditStyleProp == "post") {
				this.line.PostTextStyle = style;
			}
		},
		toggleRounding(value:boolean) {
			if (value) {
				this.line.PropRounding = 0;
			}else{
				this.line.PropRounding = null;
			}
		}
	},
	components: {
		AppColumnSelect,
		AppStyleEditor,
		AppBasicTextStyleEditor
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
